import {
  ReceivedInvoiceAiSuggestStatus,
  ReceivedInvoiceAiSuggestStatusProperty,
} from '@/context/services/invoice/type';

/** AI Suggest finished successfully — show the blue success label. */
export const isAiSuggestSuccess = (
  status?: ReceivedInvoiceAiSuggestStatusProperty
): boolean => status === ReceivedInvoiceAiSuggestStatus.success;

/** AI Suggest failed (e.g. OCR failed so AI Suggest failed) — show the yellow alert label. */
export const isAiSuggestFailed = (
  status?: ReceivedInvoiceAiSuggestStatusProperty
): boolean => status === ReceivedInvoiceAiSuggestStatus.failure;

/** Whether an AI Suggest result label should be displayed (success or failure). */
export const hasAiSuggestResult = (
  status?: ReceivedInvoiceAiSuggestStatusProperty
): boolean => isAiSuggestSuccess(status) || isAiSuggestFailed(status);
